import ReactGA from 'react-ga';
import Axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { isProduction, isElectron } from '.';
import { gaId } from '../config';

const os = require('os');

const getElectronUserAgent = () => {
  const electronVersion = window.navigator.appVersion.match(/Electron\/(.*\s)/g) || 'Unknown';
  const platform = window.navigator.appVersion.match(/\(.*\d+\) /gi) || 'Unknown Device';
  return `${electronVersion} ${platform}`;
};

export const gaInit = ({ options }) => {
  if (isProduction() && !isElectron()) {
    const initialize = ReactGA.initialize(gaId, { gaOptions: { userId: options?.userId } });

    ReactGA.set({
      campaignName: options?.companyName,
      campaignId: options?.campaignId
    });

    ReactGA.pageview(window.location.pathname + window.location.search);
    return initialize;
  }
  return false;
};

const ga = params => {
  if (!isProduction()) return null;
  const { ipcRenderer } = window.require('electron');
  const payload = new URLSearchParams({
    v: 1,
    tid: gaId,
    ua: getElectronUserAgent(),
    cid: ipcRenderer.sendSync('get-cid') || uuidv4(),
    an: os.platform(),
    av: ipcRenderer.sendSync('app_version'),
    ...params
  }).toString();
  return Axios.post('https://google-analytics.com/collect', payload);
};

export const trackEvent = ({ category, action, label, value }) => {
  if (isProduction()) {
    const payload = {
      t: 'event',
      ec: category,
      ea: action
    };
    if (label) payload.el = label;
    if (value) payload.ev = value;
    if (payload.ec && payload.ea) {
      if (isElectron()) {
        ga(payload);
      } else {
        ReactGA.event({
          category,
          action,
          label
        });
      }
    }
  }

  return null;
};

export const trackScreenView = screenName => {
  if (isProduction() && isElectron() && screenName) {
    ga({
      dh: window?.navigator?.platform,
      dr: window?.navigator?.platform,
      ds: 'desktop',
      t: 'pageview',
      dp: screenName.pathname, // Document Path
      dt: document?.title, // Document Title
      cd: document?.title // Screen Name
    });
  }
};
